module.exports = __webpack_public_path__ + "static/media/Barcode.eb5eb5bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cont/Barcode.png
// module id = 1194
// module chunks = 0